<template>
  <div
    class="is-padding-right-on-btn-actions is-padding-left-on-btn-actions"
    v-if="program">
    <tabs
      v-if="programTabLinks"
      :links="programTabLinks"
      :level="1"
      :mode="'emitter'"
      :is-fullwidth="true"
      @changeView="changeView"
      class="is-border-bottom is-margin-bottom"></tabs>
    <page-content
      :has-no-padd-on-act-on-desktop="true"
      :has-padd-left-on-act="false"
      :has-padd-right-on-act="false"
      :has-left-col-small="$route.name === 'ProgramPromoteurInfos'"
      :has-left-col-small-size-fixed="false"
      :has-sticky-col-left="true">
      <template
        slot="left-col-small"
        class="is-zindex-2">
        <div
          class="has-background-white is-border"
          id="topView">
          <div
            class="is-padding-top-small is-padding-left is-padding-right is-padding-bottom-small has-status-bar--left"
            :class="`has-status-bar--${program.status}`">
            <div class="level is-marginless">
              <div class="level-left">
                <div class="">
                  <div>
                    <span class="title is-5 has-text-weight-bold">État :</span>
                    <span class="is-margin-left-xsmall is-inline-flex">{{ program.status | workflowLabel }}</span>
                  </div>

                  <!-- <div class="control is-size-6">
                    <i>Visible par :
                      <a
                        @click="changeViewProgram('ProgramAccesses')"
                        v-scroll-to="'#topView'">{{ visibility }}
                        Prescripteur(s)</a>
                    </i>
                  </div> -->
                </div>
              </div>
              <div class="level-right">
                <div
                  class="level-item field"
                  style="margin-right:-8px;">
                  <div class="select is-transparent is-small">
                    <select
                      v-model="selected"
                      @change="updateStatus">
                      <option
                        disabled
                        value="">
                        Changer état
                      </option>
                      <option
                        v-for="status in workflowStatusList"
                        :value="status.value"
                        :key="status.label">
                        {{ status.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="control is-padding-left is-inline-block is-vcentered is-border-left is-size-6"
              v-if="program.diffusion_enabled && diffusion && diffusion.supports">
              <router-link
                :to="{ name: 'ProgramDiffusionEdit', params: {id: program.pk} }">
                <span class="underlign-hover">
                  Publié dans <b>{{ diffusion.supports.length }} support(s) de multi-diffusion(s)</b>.
                </span>
              </router-link>
            </div>
          </div>
          <div
            class="columns has-background-annonce is-vcentered is-gapless is-padding-left is-marginless"
            v-if="!program.is_optionable">
            <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall">
              <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
            </div>
            <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-white is-italic is-size-7 has-text-weight-bold">
                <span>Non optionnable</span>
              </div>
            </div>
          </div>
          <div
            class="has-background-allotement is-padding-left"
            v-if="allotments.length">
            <div class="is-padding-top-xxsmall is-padding-bottom-xxsmall">
              <router-link
                class="is-uppercase is-size-7 has-text-weight-bold has-text-white"
                :to="{name: 'ProgramAccesses'}"
                v-scroll-to="'#topView'">
                {{ allotments.length }} allotement(s)
              </router-link>
            </div>
          </div>
          <div class="columns is-gapless is-vcentered is-marginless has-background-secondary has-text-white">
            <div class="column is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
              <b>Comm {{ nameToUse }} : {{ program.remuneration ? program.remuneration + ' % HT' : '--' }}</b>
            </div>
            <div class="column is-narrow is-padding-right">
              <router-link
                class="is-linkTextPicto has-text-white is-size-6"
                :to="{ name: 'ProgramEdit', params: { id: program.pk }, query: { panel: 'FICHE_PROGRAMME' } }">
                <span><i>Modifier</i></span>
                <span class="icon"><i class="fal fa-long-arrow-right"></i></span>
              </router-link>
            </div>
          </div>
          <div class="columns is-gapless is-marginless-bottom is-multiline is-border-bottom is-border--dashed">
            <div
              class="column is-12 is-padding is-border-top is-border--dashed vadBlockHover vadBlockHover--decoration"
              @click.prevent.stop="changeViewProgram('ProgramPromoteurInfos')"
              v-scroll-to="'#mapVue'">
              <div class="columns is-gapless is-vcentered is-marginless">
                <div class="column is-paddingless has-text-grey is-size-6">
                  {{ nameToUse }}
                </div>
                <!-- <div class="column is-paddingless is-narrow">
                  <router-link :to="{name: 'ProgramEdit', params: {id: program.pk}}"
                          class="is-linkTextPicto is-size-6 has-text-dark">
                    <span><i>Modifier fiche</i></span>
                    <span class="icon"><i class="fal fa-long-arrow-right"></i></span>
                  </router-link>
                </div> -->
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-5">
                <div v-if="program.address && program.address.zip_code">
                  {{ program.address.line1 }} {{ program.address.zip_code }} {{ program.address.city }}
                </div>
                <div v-else-if="program.address && program.address.latitude && program.address.longitude">
                  Latitude : {{ program.address.latitude }} / Longitude : {{ program.address.longitude }}
                </div>
                <div v-else>
                  NC
                </div>
              </div>
              <div class="">
                <div
                  v-if="program.progress_step || program.tags.length"
                  class="is-margin-top-small">
                  <div class="tags">
                    <span
                      v-if="program.progress_step"
                      class="tag is-info">{{ program.progress_step | programStepProgressLabel }}</span>
                    <span
                      v-for="tag in program.tags"
                      :key="tag"
                      class="tag is-annonce">{{ tag }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-gapless is-multiline is-marginless">
            <div class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Dispositif(s)
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-5 is-break-word has-text-weight-medium">
                {{ taxDispositifs }}
              </div>
            </div>
            <div class="column is-6 is-border-bottom is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Zone
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-5 has-text-weight-medium">
                {{ program.tax_zone || '--' |taxZonesLabel }}
              </div>
            </div>
            <div class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Agence principale
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-5 is-break-word has-text-weight-medium">
                {{ mainAgence ? mainAgence.name : '--' }}
              </div>
            </div>
            <div class="column is-6 is-border-bottom is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Agences commercialisatrices
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-5 has-text-weight-medium">
                <router-link
                  :to="{name: 'AgenceAccessLightList'}"
                  v-scroll-to="'#topView'">
                  {{ agenceAccess.length }} agence(s)
                </router-link>
              </div>
            </div>
            <div
              v-if="program.is_amenagement"
              class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Type d'opération
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-5 has-text-weight-medium">
                {{ program.operation_type || '--' | operationTypeLabel }}
              </div>
            </div>
            <div class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Actabilité
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-5 has-text-weight-medium">
                {{ program.date_actabilite || '--' |
                  prettyTrimestre }}
              </div>
            </div>
            <div class="column is-6 is-border-bottom is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall">
              <div class="has-text-grey is-size-6">
                Livraison
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-5 has-text-weight-medium">
                {{ program.date_livraison || '--' |
                  prettyTrimestre }}
              </div>
            </div>
            <div
              class="column is-6 is-border-right is-border--dashed columns is-column is-space-between is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall"
              v-if="program.is_amenagement">
              <div class="has-text-grey is-size-6">
                Date butoir de dépôt PC
              </div>
              <div class="is-margin-top-xsmall has-text-primary is-size-5 has-text-weight-medium">
                {{ deadline_date || '--' }}
              </div>
            </div>
          </div>
          <div
            v-if="!program.use_tranche"
            class="is-padding">
            <div class="is-margin-bottom-xsmall">
              <span class="title is-5">OBJECTIF GFA*</span>
              <span
                class="is-padding-left-xsmall"
                v-helper.bottom="'37up8jyDO5c6qQWzcHkkKZ'">
                <i class="fal fa-info-circle"></i>
              </span>
            </div>
            <program-progress-bar
              class=" is-margin-bottom-xsmall"
              :classes="'is-success has-glueValue is-xxlarge is-radiusless'"
              :value="program.lot_resume.gfa_percentage"
              :max="100"
              :value-human="`${normalizedValueGFA(program.lot_resume.gfa_percentage)}%`"
              :display-value="true"></program-progress-bar>
            <div class="is-size-6 has-text-primary is-italic">
              *Réservation(s) au {{ today | dtFormat('DD/MM/YYYY') }}
            </div>
          </div>
          <div v-else-if="tranches && tranches.length">
            <div
              v-for="(tranche, i) in tranches"
              :key="i">
              <div class="is-flex-between is-padding-left-small is-padding-right-small is-padding-top-xsmall is-padding-bottom-xsmall is-border-top is-border--dashed">
                <span class="is-uppercase has-text-weight-medium">{{ tranche.name }}</span>
                <i
                  v-if="!openTranchesDetail.includes(i)"
                  @click="toggleTranchesDetail(i)"
                  class="is-size-6 is-underline has-cursor-pointer">Voir le détail</i>
                <i
                  v-else
                  @click="toggleTranchesDetail(i)"
                  class="is-size-6 is-underline has-cursor-pointer">Masquer le détail</i>
              </div>
              <div
                v-if="openTranchesDetail.includes(i)"
                class="is-flex-between is-padding-left-small is-padding-right-small is-padding-top-xsmall is-padding-bottom-xsmall is-border-top is-border--dashed has-background-white-ter">
                <span class="is-size-6 has-text-grey">GFA : <span class="is-size-5 has-text-black">{{ normalizedValueGFA(tranche.gfa_percentage) }}%</span></span>
                <span class="is-size-6 has-text-grey">Actabilité : <span class="is-size-5 has-text-black">{{ tranche.date_actabilite || '--' | prettyTrimestre }}</span></span>
                <span class="is-size-6 has-text-grey">Livraison : <span class="is-size-5 has-text-black">{{ tranche.date_livraison || '--' | prettyTrimestre }}</span></span>
              </div>
            </div>
          </div>
          <div class="columns is-gapless">
            <div
              v-if="program.certifications && program.certifications.length > 0"
              class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small">
              <div class="is-flex is-wrap-flex">
                <span
                  v-for="(certification, index) in program.certifications"
                  :key="index">
                  <img
                    class="img--certification is-padding-right-xsmall"
                    :src="certification | programCertificationImage"
                    :alt="certification | programCertificationLabel">
                </span>
              </div>
            </div>
          </div>
        </div>
        <event-tracker-list :field="'program'"></event-tracker-list>
      </template>
      <router-view
        :key="$route.name"
        :program="program"
        :program-lots="lots"
        :program-autres="autres"
        :program-parkings="parkings"
        :loading="loading"
        :no-more-result="noMoreResult"
        :no-parking-more-result="noParkingMoreResult"
        :no-autre-more-result="noMoreResult"
        :program-lots-count="programLotsCount"
        :program-parkings-count="programParkingsCount"
        :program-autres-count="programAutresCount"
        :accesses="accesses"
        :mandats="mandats"
        :agence-access="agenceAccess"
        :accesses-count="accessesCount"
        :current-access-page="currentAccessPage"
        :current-access-total-page="currentAccessTotalPage"
        :current-agence-page="currentAgencePage"
        :current-agence-total-page="currentAgenceTotalPage"
        :current-canal-page="currentCanalPage"
        :current-canal-total-page="currentCanalTotalPage"
        :program-options="programOptions"
        :program-allotments="allotments"
        :lot-pages="lotPages"
        :parking-pages="parkingPages"
        :autre-pages="autrePages"
        :current-lot-page="currentLotPage"
        :current-parking-page="currentParkingPage"
        :current-autre-page="currentAutrePage"
        @deleteAccess="deleteAccess"
        @getProgramAccesses="getProgramAccesses"
        @getProgramLots="getProgramLots"
        @getProgramParkings="getProgramParkings"
        @getProgramAutres="getProgramAutres"></router-view>
    </page-content>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'
import { concat } from 'lodash'
import ProgramProgressBar from './ProgramRightPanel/ProgramProgressBar'
import { mapGetters } from 'vuex'
import moment from 'moment'
const removeMd = require('remove-markdown')

export default {
  name: 'ProgramPromoteurVue',
  components: { ProgramProgressBar },
  mixins: [DefaultValues],
  props: {
    program: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      deadline_date: this.program.construction_data.deadline_pc_date,
      currentLotPage: 1,
      currentParkingPage: 1,
      currentAutrePage: 1,
      lotPages: null,
      parkingPages: null,
      autrePages: null,
      noMoreResult: false,
      noParkingMoreResult: false,
      noAutreMoreResult: false,
      programLotsCount: 0,
      programParkingsCount: 0,
      programAutresCount: 0,
      lotsTotal: 0,
      selected: '',
      visibility: 0,
      diffusion: null,
      lots: [],
      parkings: [],
      autres: [],
      accesses: [],
      mandats: [],
      agenceAccess: [],
      accessesCount: 0,
      currentAccessPage: 1,
      currentAccessTotalPage: 0,
      currentAgencePage: 1,
      currentAgenceTotalPage: 0,
      currentCanalPage: 1,
      currentCanalTotalPage: 0,
      allotments: [],
      programOptions: [],
      tranches: [],
      openTranchesDetail: []
    }
  },
  computed: {
    ...mapGetters(['isPromoteur', 'isAdmin']),
    mainAgence () {
      return this.program ? this.program.main_agence : null
    },
    nameToUse () {
      if (this.program && this.program.is_amenagement) {
        return 'Lotissement'
      } else {
        return 'Programme'
      }
    },
    /**
       * today
       * @returns {date}
       */
    today () {
      return moment()
    },
    // gfa_percent () {
    //   if (((this.gfa * 100) / this.gfa_total) > 100) {
    //     return 100
    //   } else {
    //     return (this.gfa * 100) / this.gfa_total
    //   }
    // },
    // gfa () {
    //   return this.program.reserved_lots + this.program.sold_lots
    // },
    // gfa_total () {
    //   return (this.program.reserved_lots + this.program.sold_lots + this.program.available_lots) / 2
    // },
    programView () {
      return this.$route.name
    },
    programPk () {
      return this.$route.params.id
    },
    // availableLot () {
    //   if (this.lots && this.lots.length) {
    //     let okStatus = ['available', 'optioned']
    //     return this.lots.filter(x => okStatus.includes(x.status)).length
    //   } else return 0
    // },
    programTabLinks () {
      let tabs = []
      tabs.push({ link: 'ProgramPromoteurInfos', label: 'FICHE ' + this.nameToUse.toUpperCase() })
      tabs.push({ link: 'ProgramLots', label: `TABLEAU DES LOTS (${this.lotsTotal} DISPONIBLES)` })
      tabs.push({ link: 'ProgramAccesses', label: 'COMMERCIALISATION' })
      tabs.push({ link: 'ProgramStats', label: 'ACTIVITÉ COMMERCIALE' })
      return tabs
    },
    taxDispositifs () {
      return this.program.tax_dispositifs.map(x => (this.taxDispositifsData[x]) ? this.taxDispositifsData[x].label : x).join(', ')
    }
  },
  watch: {
    'programView' (v) {
      if (v === 'ProgramAccesses' && !this.accesses.length) {
        this.getProgramAccesses(1)
      }
      if (v === 'ProgramOptions' && !this.programOptions.length) {
        this.getProgramOptions()
      }
    }
  },
  created () {
    if (this.deadline_date != null) {
      this.deadline_date = moment(this.deadline_date).format('DD-MM-YYYY')
    }
    if (!this.programTabLinks.map(x => x.link).includes(this.programView)) {
      this.$router.replace({ name: 'ProgramPromoteurInfos' }).catch(() => {})
    }
    this.getProgramLots()
    this.getProgramParkings()
    this.getProgramAutres()
    this.getProgramLotsCount()
    this.getProgramTranches()
    if (this.program && this.program.diffusion_enabled) {
      this.getProgramDiffusion()
    }
    this.getProgramAllotments()
    this.getProgramVisibility()
    this.getProgramAgenceAccess()
  },
  methods: {
    normalizedValueGFA (value) {
      return Math.min(value, 100)
    },
    toggleTranchesDetail (index) {
      if (this.openTranchesDetail.findIndex(x => x === index) === -1) this.openTranchesDetail.push(index)
      else this.openTranchesDetail.splice(this.openTranchesDetail.findIndex(x => x === index), 1)
    },
    changeView (link) {
      this.$router.push({ name: link })
    },
    async getProgramTranches () {
      try {
        let { data } = await this.$api.get(this.$resources.PROGRAM_TRANCHE(this.programPk))
        this.tranches = data.items
      } catch (error) {
        console.error(error)
      }
    },
    async getProgramOptions (page = 1) {
      let params = {
        program: this.programPk,
        page
      }
      try {
        let { data } = await this.$api.get(this.$resources.OPTION, params)
        if (page > 1) {
          let totalOptions = concat(data.items, this.programOptions)
          this.programOptions = totalOptions
        } else {
          this.programOptions = data.items
        }
        if (data.page < data.pages) {
          page++
          this.getProgramOptions(page)
        }
      } catch (e) {
        console.log(e)
      }
    },
    changeViewProgram (link) {
      if (link === 'ProgramAccesses') {
        this.$router.push({ name: link })
      } else {
        this.$router.replace({ name: link }).catch(() => {})
      }
    },
    async deleteAccess (pk) {
      let value = await this.$swal({
        title: 'Suppression mandat',
        text: 'La société n\'aura plus accès au ' + this.nameToUse + ', cette action entrainera également l\'annulation de ses options sur ce ' + this.nameToUse + '.',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value && value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        try {
          await this.$api.delete(this.$resources.ACCESS, pk)
          this.$toasted.global.success('Mandat supprimé')
          await this.getProgramAccesses()
        } catch (err) {
          this.handleError(err)
          console.log(err)
        }
      }
    },
    async getProgramVisibility () {
      try {
        let { data } = await this.$api.get(this.$resources.PROGRAM_VISIBILITY(this.programPk))
        this.visibility = data
      } catch (e) {
        console.log(e)
      }
    },
    async getProgramDiffusion () {
      try {
        let { data } = await this.$api.get(this.$resources.PROGRAM_MGC_PARAMS(this.programPk))
        this.diffusion = data
      } catch (err) {
        console.log(err)
      }
    },
    async getProgramAccesses (page = 1, perPage = 50) {
      if (this.isPromoteur && this.isAdmin) {
        let accessParams = { program: this.programPk, page, per_page: perPage }
        let mandatsParams = { program: this.programPk }
        try {
          let { data } = await this.$api.get(this.$resources.ACCESS, accessParams)
          this.accesses = data.items
          this.accessesCount = data.count
          this.currentAccessPage = data.page
          this.currentAccessTotalPage = data.pages
          this.getProgramAllotments()
        } catch (e) {
          console.log(e)
        }
        try {
          let { data } = await this.$api.get(this.$resources.MANDAT, mandatsParams)
          this.mandats = data.items
        } catch (e) {
          console.log(e)
        }
        await this.getProgramAgenceAccess()
      }
    },
    async getProgramAgenceAccess () {
      if (this.isPromoteur && this.isAdmin) {
        try {
          let { data } = await this.$api.get(this.$resources.AGENCE_ACCESS, { program: this.programPk })
          this.agenceAccess = data.items
        } catch (e) {
          console.log(e)
        }
      }
    },
    async updateStatus () {
      const status = this.selected
      if (this.selected !== null && this.selected !== '') {
        const cb = () => {
          let IDS = {
            archived: 'zLynaCi2aWaUMuGIcwaqg',
            draft: '2SRdlfVm9O0Ae444SW40sM',
            available: '4ncpu5K3ks66cO8wmo8EYC'
          }
          let entryId = IDS[status]
          if (entryId && this.$contentful) {
            this.$contentful.getEntry(entryId).then(entry => {
              let text = entry.fields.text
              let msg = removeMd(text)
              this.$toasted.global.success(msg)
            })
          } else if (entryId) {
            this.$toasted.global.success(this.nameToUse + ' mis à jour.')
          }
        }
        this.selected = ''
        await this.patchProgram({ status }, cb)
      }
    },
    async patchProgram (patchedProgram, cb = null) {
      patchedProgram.force = true
      try {
        let { data } = await this.$api.patch(this.$resources.PROGRAM, this.program.pk, patchedProgram)
        this.$emit('updateProgram', data)
        if (cb && typeof cb === 'function') cb()
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    async getProgramAllotments (page = 1) {
      let params = { program: this.programPk, page: page }
      let { data } = await this.$api.get(this.$resources.ALLOTMENT_ALL, params)
      this.allotments = data.all_allotment
    },
    async getProgramLotsCount () {
      let params = {
        program: this.programPk,
        per_page: 1,
        status: ['available', 'optioned']
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.lotsTotal = data.count
      } catch (e) {
        console.log(e)
      }
    },
    async getProgramLots (filters = {}, page = 1) {
      let fullPath = this.$route.fullPath
      let pageNumber
      if (fullPath.includes('?page') && this.$route.meta.parentName === 'ProgramVue') {
        let match = fullPath.match(/\?page=(\d+)/)
        pageNumber = match[1]
        page = pageNumber
      }
      let params = {
        program: this.programPk,
        page,
        per_page: 50,
        nature: ['lot', 'flat', 'house', 'field', 'commercial', 'office', 'bedroom'],
        ...filters
      }
      this.loading = true
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.lots = data.items
        this.programLotsCount = data.count
        this.lotPages = data.pages
        this.currentLotPage = data.page
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de la récupération des lots !')
      } finally {
        this.loading = false
      }
    },
    async getProgramParkings (filters = {}, page = 1) {
      this.noParkingMoreResult = false
      this.loading = true
      let params = {
        program: this.programPk,
        page,
        per_page: 50,
        nature: ['parking'],
        ...filters
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.parkings = data.items
        this.programParkingsCount = data.count
        this.parkingPages = data.pages
        this.currentParkingPage = data.page
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async getProgramAutres (filters = {}, page = 1) {
      this.noAutreMoreResult = false
      this.loading = true
      let params = {
        program: this.programPk,
        page,
        per_page: 50,
        nature: ['garden', 'annexe'],
        ...filters
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.autres = data.items
        this.programAutresCount = data.count
        this.autrePages = data.pages
        this.currentAutrePage = data.page
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
